import moment from "moment";

export function findTimeElapsedSinceMidnight(date: Date): moment.Duration {
	return moment.duration(moment(date).format("HH:mm:ss"));
}
